/**
 * Whether the cookie banner is currently on screen.
 *
 * `CommonCookieBanner` owns the flag; other bottom-pinned UI reads it so it can
 * step aside while consent is still being asked for. Shared state rather than a
 * second reading of the banner's storage keys: those say what was decided in
 * some earlier session, not whether the card is on the screen right now, and a
 * copy of that logic would go stale the moment the banner's rules change.
 */
export function useCookieBannerVisible() {
  return useState('cookie-banner-visible', () => false)
}
